var map = {
	"../pages/about/about.module": [
		843,
		39
	],
	"../pages/agregar-testimonio/agregar-testimonio.module": [
		844,
		38
	],
	"../pages/categorias-de-nota/categorias-de-nota.module": [
		845,
		37
	],
	"../pages/comentario-de-comentario/comentario-de-comentario.module": [
		846,
		36
	],
	"../pages/comunidad/comunidad.module": [
		847,
		35
	],
	"../pages/cuestionario/cuestionario.module": [
		848,
		34
	],
	"../pages/detalle-comunidad/detalle-comunidad.module": [
		849,
		33
	],
	"../pages/detalles-evento/detalles-evento.module": [
		850,
		32
	],
	"../pages/detalles-ficha/detalles-ficha.module": [
		851,
		31
	],
	"../pages/detalles-formato-documento/detalles-formato-documento.module": [
		852,
		30
	],
	"../pages/detalles-item-negocio/detalles-item-negocio.module": [
		853,
		29
	],
	"../pages/detalles-item-tip/detalles-item-tip.module": [
		854,
		28
	],
	"../pages/detalles-nota-usuario/detalles-nota-usuario.module": [
		855,
		27
	],
	"../pages/detalles-promocion/detalles-promocion.module": [
		856,
		26
	],
	"../pages/editar-datos-usuario/editar-datos-usuario.module": [
		857,
		0
	],
	"../pages/educacion-continua/educacion-continua.module": [
		858,
		25
	],
	"../pages/favoritos/favoritos.module": [
		859,
		24
	],
	"../pages/final-cuestionario-correcto/final-cuestionario-correcto.module": [
		860,
		23
	],
	"../pages/final-cuestionario/final-cuestionario.module": [
		861,
		22
	],
	"../pages/home/home.module": [
		862,
		21
	],
	"../pages/listado-eventos/listado-eventos.module": [
		863,
		20
	],
	"../pages/listado-fichas/listado-fichas.module": [
		864,
		19
	],
	"../pages/listado-formatos-y-documentos/listado-formatos-y-documentos.module": [
		865,
		18
	],
	"../pages/listado-negocios/listado-negocios.module": [
		866,
		17
	],
	"../pages/listado-notas-usuario/listado-notas-usuario.module": [
		867,
		16
	],
	"../pages/listado-promociones/listado-promociones.module": [
		868,
		15
	],
	"../pages/listado-tips/listado-tips.module": [
		869,
		14
	],
	"../pages/log/log.module": [
		870,
		13
	],
	"../pages/mas/mas.module": [
		871,
		12
	],
	"../pages/modal-busqueda/modal-busqueda.module": [
		872,
		11
	],
	"../pages/nota-detalles/nota-detalles.module": [
		873,
		10
	],
	"../pages/notas-alfabeticamente/notas-alfabeticamente.module": [
		874,
		9
	],
	"../pages/notas-de-categoria/notas-de-categoria.module": [
		875,
		8
	],
	"../pages/on-boarding/on-boarding.module": [
		876,
		1
	],
	"../pages/tab-fichas/tab-fichas.module": [
		877,
		7
	],
	"../pages/tab-inicio/tab-inicio.module": [
		878,
		6
	],
	"../pages/tab-negocio/tab-negocio.module": [
		879,
		5
	],
	"../pages/tab-tips/tab-tips.module": [
		880,
		4
	],
	"../pages/tab-usos/tab-usos.module": [
		881,
		3
	],
	"../pages/ver-comunidad/ver-comunidad.module": [
		882,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 227;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 227
// module chunks = 40